// Shared animation constants to avoid inline object creation in render
export const fadeInUp = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.15 }
};

export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 }
};

export const slideInLeft = {
  initial: { opacity: 0, x: -10 },
  animate: { opacity: 1, x: 0 }
};

// Chart tooltip style
export const chartTooltipStyle = {
  backgroundColor: '#2C3036',
  border: '1px solid #334155',
  borderRadius: '0.5rem'
};

export const chartLabelStyle = { color: '#F8FAFC' };

export const barRadius = [4, 4, 0, 0];
